import React from "react";

import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';

import Icon from 'components/LM/common/VoiceRelationsIcons';
import ExportCSV from "components/LM/common/ExportCSV";
import Breadcrumb from "components/LM/common/Breadcrumb";

const CSV_COLUMNS = [
	{ id: 'voice_id', displayName: 'Voice id' },
	{ id: 'voice_name', displayName: 'Voice name' },
	{ id: 'profile_type', displayName: 'Profile type' },
	{ id: 'profile_id', displayName: 'Profile id' },
	{ id: 'profile_name', displayName: 'Profile name' },
	{ id: 'status', displayName: 'Status' },
	{ id: 'message', displayName: 'Message' },
];

function Results({ location }) {

	if (!location.state) {
		return <h2>There's nothing to show</h2>;
	}


	const { results, types } = location.state;

	const voiceResults = results.map(voice => <VoiceResult key={`voice_${voice.id}`} voice={voice} types={types} />);
	return <>
		<Breadcrumb items={['Voices', 'Mass Recovery Result']} />
		<ExportCSV
			className="pb-3"
			columns={CSV_COLUMNS}
			datas={() => buildCsv(results, types)}
			filename="massRecoveryResults"
			buttonText="Export as CSV" />

		{voiceResults}
	</>;
}

function VoiceResult({ voice, types }) {

	let profilesResults;
	if (voice.error) {
		profilesResults =
			<Card.Text as="h3">⚠️ {voice.error}</Card.Text>
	} else {
		profilesResults = <ProfilesTable voice={voice} types={types} />;
	}

	return (
		<Card>
			<Card.Header as="h3">
				<a href={`/voices/${voice.id}`} target="_blank" rel="noreferrer">{voice.id}</a>
				<span className="ml-2">{voice.name}</span>
			</Card.Header>
			<Card.Body>
				{profilesResults}
			</Card.Body>
		</Card>
	);
}

function ProfilesTable({ voice, types }) {

	const profileRows = [];
	types.sort().forEach(type => {
		if (voice[type].length > 0) {
			voice[type].forEach(profile => profileRows.push(<ProfileRow key={`${type}_${profile.id}`} profile={profile} type={type} />));
		} else {
			profileRows.push(<tr key={`${type}_missing`}>
				<td colSpan={3}>
					<Icon type={type} size="16" />
					<span className="ml-2">There are no {type} profiles</span>
				</td>
			</tr>);
		}
	});

	return (
		<Table striped bordered hover>
			<thead className="thead-light">
				<tr>
					<th className="w-25">#</th>
					<th>Name</th>
					<th className="w-25">Status</th>
				</tr>
			</thead>
			<tbody>{profileRows}</tbody>
		</Table>
	);
}

function ProfileRow({ profile, type }) {
	return (
		<tr>
			<td>
				<Icon type={type} size="16" />
				<a className="ml-2" href={`/${type}/profile?id=${profile.id}`} target="_blank" rel="noreferrer">{profile.id}</a>
			</td>
			<td>{profile.name}</td>
			<td><ProfileRowStatus success={profile.success} message={profile.message} /></td>
		</tr>
	);
}

function ProfileRowStatus({ success, message }) {
	if (success) {
		return "✅ Submitted";
	} else {
		return <>❌ {message}</>;
	}
}

function buildCsv(results, types) {

	const rows = [];

	results.forEach(voice => {
		if (voice.error) {
			rows.push({ voice_id: voice.id, status: "Missing voice", message: voice.error });
			return;
		}

		types.sort().forEach(type => {
			const row = {
				voice_id: voice.id,
				voice_name: voice.name,
				profile_type: type,
			};

			if (voice[type].length > 0) {
				voice[type].forEach(profile => {
					rows.push({
						...row,
						profile_id: profile.id,
						profile_name: profile.name,
						status: profile.success ? "Submitted" : "Error",
						message: profile.success ? "The recovery has been submitted" : profile.message
					});
				});
			} else {
				rows.push({
					...row,
					status: "No profiles",
					message: "There are no profiles of this type"
				});
			}
		});
	});

	return rows;
}

export default Results;
